import React, { useState, useEffect, useRef, useMemo } from 'react';
import {StyledLeadContainer,  CreateLeadFooter, StyledSubHeader, StyledGridContainer} from '../../Components/Styled/index';
import { Box, Button, Stack, Typography,} from '@mui/material';
import { privateRoutesPath } from '../../Routes';
import {useSnackbar} from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import BiztantuLoader from '../../Components/Loader';
import { requestShowLoader, requestHideLoader } from '../../Store/Global/action';
import DocumentManagement from '../../Components/DocumentManagement';
import { ACTIVE_STATUS, ADDITIONAL_ATTRIBUTE_FIELDS, handleValidateCodevalue, PRODUCT_DOC_TYPE, PRODUCT_STATUS, PRODUCT_TYPE, PRODUCT_UOM, searchEntity, STATIC_ENTITY_CONFIG } from '../../Utility/constant';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import WhoColumnTextfieds from '../../Components/WhoColumnTextfieds';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import LeadAccordion from '../../Components/LeadAccordion';
import AuditLogs from '../Configuration/Audit';
import { getEntityColumns, getRequestData, updateRequestData, validateFields } from '../../Utility/apiHelper';
import { EntityNote } from '../../Components/EntityNote';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import { formatAdditionalAttributesForPayload } from '../../Utility/payloadFormatter';
import CustomizableFields from '../../Components/CustomizableFields';
import { requestGetAllMerchant } from '../../Store/Merchant/action';
import { useAccordionData } from '../../Utility/hooks/useAccordionData';
import useNavigation from '../../Utility/hooks/useNavigation';
import './product.css';

const EditProduct = (props) => {
    const [productDetail, setProductDetail] = useState();
    const [initialProductDetails,setInitialProductDetails] = useState();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const merchantData = useSelector(state => state?.merchant?.merchant || []);
    const dispatch = useDispatch();
    const isLoadingProgress = useSelector(state => state.global.isLoading);
    const productId = props.match.params.id;
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const productTypeData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const productStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const productUOMData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_UOM)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);  
    const docType = useSelector(state=> state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_DOC_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);                  
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const [isRequired, setRequired] = useState(false);
    const inputRef = useRef(null);
    const { goBackTo } = useNavigation();
   const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const canEdit = !!specificRolePermission?.isProductManage;
    const [isEntityLocked, setIsEntityLocked] = useState(false);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);
    const productTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "PRODUCT");
            return Object.keys(data).length > 0 ?  data : STATIC_ENTITY_CONFIG?.PRODUCT;

    }, [allEntityData]);
    const isViewMode = !canEdit || isEntityLocked;
    // Audit Logs accordion — controlled via useAccordionData; fetches lazily on expand
    const auditAccordion = useAccordionData(null, { refetchOnEveryOpen: true, unmountOnExit: true });
    const setIsAuditAccordionExpanded = auditAccordion.setIsExpanded;
    useEffect(() => {
        getProductDetails(productId);
        dispatch(requestGetAllMerchant());   
    },[productId])

    const goBack = () => goBackTo(privateRoutesPath.PRODUCT,searchEntity?.product);
    const getProductDetails = async (productId) => {
        dispatch(requestShowLoader())

        try {
            const response = await getRequestData(`products/${productId}`);

            const productData = response?.data;
            const filteredVendor = merchantData.find(
                item => item?.id === productData?.vendorId
            );

            setProductDetail({
                ...productData,
                selectedVendor: filteredVendor,
            });

            setInitialProductDetails({
                ...productData,
                selectedVendor: filteredVendor,
            });
        } catch (error) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });

        } finally {
            dispatch(requestHideLoader());
        }
    }

    const handleChangeProductField = (event) => {
        setProductDetail({
            ...productDetail,
            [event.target.name]: event.target.value
        })
    }

    const handleUpdateProduct = async (value = false) => {

        const {errors,hasError} = validateFields(productTextfieldsData, productDetail);
            if (hasError) {
                setRequired(errors);
                    enqueueSnackbar(
                        handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"),
                    { variant: "error" }
                );
                return;
            } else {
        if(JSON.stringify(productDetail) == JSON.stringify(initialProductDetails)){
            if(value == true){
                goBack();
            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED") , {variant : 'info'});
            }
        }
        else{

        const {created, id, updated ,...UpdatedproductData} = productDetail;
         const payload = formatAdditionalAttributesForPayload(
            {             
            ...UpdatedproductData,
            },
            ADDITIONAL_ATTRIBUTE_FIELDS
        );
                    
        dispatch(requestShowLoader())
        
        try {
            await updateRequestData(
                payload,
                `products/${productDetail.id}`
            );

            enqueueSnackbar(
                handleValidateCodevalue(
                    internationalise,
                    "COMMON_UPDATED_SUCCESSFULLY"
                ),
                { variant: "success" }
            );

            getProductDetails(productId);
            setIsAuditAccordionExpanded(false);

            if (value === true) {
                goBack();
            }
        } catch (error) {
            enqueueSnackbar(
                handleValidateCodevalue(
                    internationalise,
                    error?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"
                ),
                { variant: "error" }
            );
        } finally {
            dispatch(requestHideLoader());
        }
    }}
    }

    // const handleSave = async() => {
    //     const reqUrl = `${process.env.REACT_APP_BASE_URL}products/${productId}`
    //     const response =  await requestDeleteApiCall(reqUrl);
    //     if(response?.status == 204) {
    //             enqueueSnackbar('Product deleted successfully.', {variant: 'success'});
    //             history.push(`${privateRoutesPath.PRODUCT}`)
    //     }
    // }

    const handleChangeDocument = (event) => {

        const file = event.target.files[0];

        if(file) {
            setSelectedDocumentType({
                ...selectedDocumentType,
                [event.target.name]: file
            })

        } else {
            setSelectedDocumentType({
                ...selectedDocumentType,
                [event.target.name]: event.target.value
            })
        }
       
    }

    const handleUploadDocument = () => {

    }

    const handleAuditAccordionChange = auditAccordion.onAccordionChange;
    
    const handleSelectCompany =(e,val,entity)=>{
        if(entity === "Vendor"){
        setProductDetail({
            ...productDetail,
            selectedVendor : val,
            vendorId : val?.id
        })
        }
    }

    return (
        <BiztantuLoader open={isLoadingProgress} isChildren={true}>
             <Box className='globalBox'>
                {/* <StyledSubHeader>
                     {handleValidateCodevalue(internationalise,'PROD_EDIT_PRODUCT_DETAILS')}
                </StyledSubHeader> */}
                <LeadAccordion
                    label={`${handleValidateCodevalue(internationalise,'PROD_EDIT_PRODUCT_DETAILS')} - ${productId}`}
                    defaultOpen={true}
                >
                {
                !isViewMode &&
                
                <Box className = "mt-15 mb-10">
                <Button className='edit-primary' variant="outlined" onClick={handleUpdateProduct}>{handleValidateCodevalue(internationalise,'COMMON_SAVE')}</Button>
                <Button  className='edit-primary btn-space'variant="outlined" onClick={()=>handleUpdateProduct(true)}>{handleValidateCodevalue(internationalise,'COMMON_SAVE_AND_EXIT')}</Button>
                </Box>
            }
                <StyledGridContainer>
                <TextFiledWithLabel 
                        id="id" 
                        name="id"
                        value={productDetail?.id}
                        handleOnChange={handleChangeProductField}
                        label={handleValidateCodevalue(internationalise,'PROD_EDIT_PRODUCT_ID')}
                        disabled={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                   
                    <TextFiledWithLabel
                        disabled = {isViewMode}
                        name="name"
                        required={true}
                        error={ productDetail?.name ? false : isRequired?.name}
                        inputRef={inputRef}
                        label={handleValidateCodevalue(internationalise,'PROD_EDIT_PRODUCT_NAME')}
                        handleOnChange={handleChangeProductField}
                        value={productDetail?.name}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        disabled = {isViewMode}
                        error={ productDetail?.status ? false : isRequired?.status}
                        required = {true}
                        name= "status"
                        value= {productDetail?.status || ""}
                        isStatic={false}
                        optionMenuItem={productStatusData}
                        label={handleValidateCodevalue(internationalise,'PRODUCT_STATUS')}
                        handleOnChange={handleChangeProductField}
                    />
                    </StyledGridContainer>

                <StyledLeadContainer className="product-description-container">
                    <TextFiledWithLabel
                        className="product-description-field"
                        disabled = {isViewMode}
                        name="description"
                        label={handleValidateCodevalue(internationalise,'PROD_EDIT_DESCRIPTION')}
                        handleOnChange={handleChangeProductField}
                        value={productDetail?.description}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </StyledLeadContainer>
                <StyledGridContainer>
                    
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        disabled = {isViewMode}
                        required = {true}
                        error={ productDetail?.type ? false : isRequired?.type}
                        value={productDetail?.type || ""}
                        name="type"
                        label={handleValidateCodevalue(internationalise,'PRODUCT_TYPE')}
                        handleOnChange={handleChangeProductField}
                        optionMenuItem={productTypeData}
                        isStatic={false}
                    />
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        disabled = {isViewMode}
                        error = {productDetail?.unitOfMeasurement? false : isRequired?.unitOfMeasurement}
                        required = {true}
                        name= "unitOfMeasurement"
                        value= {productDetail?.unitOfMeasurement || ""}
                        isStatic={false}
                        optionMenuItem={productUOMData}
                        label={handleValidateCodevalue(internationalise,'PRODUCT_UOM')}
                        handleOnChange={handleChangeProductField}
                    />
                    {(productTextfieldsData?.selectedVendor?.visibility && specificRolePermission?.isVendorView) &&
                    <AutoCompleteComponent
                        isViewMode={isViewMode}
                        optionSet = {merchantData}
                        error = {productDetail?.selectedVendor? false : isRequired?.selectedVendor}
                        required={productTextfieldsData?.selectedVendor?.mandatory}
                        value={productDetail?.selectedVendor || null}
                        name = "vendorId"
                        placeholder={handleValidateCodevalue(internationalise,'PROD_EDIT_VENDOR')}
                        label={handleValidateCodevalue(internationalise,'PROD_EDIT_VENDOR')}       
                        onChange={(e, val) => handleSelectCompany(e, val, "Vendor")}
                    />
                    }
                </StyledGridContainer>
                 <WhoColumnTextfieds
                entityDetails={productDetail}
                 />
                 
                 <StyledSubHeader>
                     {handleValidateCodevalue(internationalise,'PROD_EDIT_PRICING')}
                </StyledSubHeader>
                <StyledGridContainer>
                    {productTextfieldsData?.mrp?.visibility &&
                    <TextFiledWithLabel
                        disabled = {isViewMode}
                        id="mrp"
                        type = "number"
                        name="mrp"
                        error = {productDetail?.mrp? false : isRequired?.mrp}
                        required={productTextfieldsData?.mrp?.mandatory}
                        value={productDetail?.mrp}
                        handleOnChange={handleChangeProductField}
                        label={handleValidateCodevalue(internationalise,'PROD_EDIT_MRP')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    }
                    
                    <TextFiledWithLabel
                    disabled = {isViewMode}
                    id="sellingPrice"
                    type = "number"
                    required={true}
                    name="sellingPrice"
                    error = {productDetail?.sellingPrice ? false : isRequired?.sellingPrice}
                    value={productDetail?.sellingPrice}
                    handleOnChange={handleChangeProductField}
                    label={handleValidateCodevalue(internationalise, 'PROD_EDIT_SP')}
                    InputLabelProps={{
                    shrink: true,
                    }}
                  />
                    {productTextfieldsData?.discount1Percentage?.visibility &&
                    <TextFiledWithLabel
                        disabled = {isViewMode}
                        id="discount1Percentage"
                        type = "number"
                        name="discount1Percentage"
                        error = {productDetail?.discount1Percentage ? false : isRequired?.discount1Percentage}
                        required={productTextfieldsData?.discount1Percentage?.mandatory}
                        value={productDetail?.discount1Percentage}
                        handleOnChange={handleChangeProductField}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_DISCOUNT1_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />}

                    {productTextfieldsData?.discount2Percentage?.visibility &&
                    <TextFiledWithLabel
                        disabled = {isViewMode}
                        id="discount2Percentage"
                        type = "number"
                        name="discount2Percentage"
                        error = {productDetail?.discount2Percentage ? false : isRequired?.discount2Percentage}
                        required={productTextfieldsData?.discount2Percentage?.mandatory}
                        value={productDetail?.discount2Percentage}
                        handleOnChange={handleChangeProductField}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_DISCOUNT2_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    }

                    {productTextfieldsData?.discount3Percentage?.visibility &&
                    <TextFiledWithLabel
                        disabled = {isViewMode}
                        id="discount3Percentage"
                        type = "number"
                        name="discount3Percentage"
                        error = {productDetail?.discount3Percentage ? false : isRequired?.discount3Percentage}
                        required={productTextfieldsData?.discount3Percentage?.mandatory}
                        value={productDetail?.discount3Percentage}
                        handleOnChange={handleChangeProductField}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_DISCOUNT3_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    }

                    <TextFiledWithLabel
                        disabled = {isViewMode}
                        id="cgstPercentage"
                        type = "number"
                        name="cgstPercentage"
                        value={productDetail?.cgstPercentage}
                        handleOnChange={handleChangeProductField}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_CGST_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextFiledWithLabel
                        disabled = {isViewMode}
                        id="sgstPercentage"
                        type = "number"
                        name="sgstPercentage"
                        value={productDetail?.sgstPercentage}
                        handleOnChange={handleChangeProductField}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_SGST_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    
                    {productTextfieldsData?.surchargePercentage?.visibility &&
                    <TextFiledWithLabel
                        disabled = {isViewMode}
                        id="surchargePercentage"
                        type = "number"
                        name="surchargePercentage"
                        error = {productDetail?.surchargePercentage ? false : isRequired?.surchargePercentage}
                        value={productDetail?.surchargePercentage}
                        required={productTextfieldsData?.surchargePercentage?.mandatory}
                        handleOnChange={handleChangeProductField}
                        label={handleValidateCodevalue(internationalise, 'PROD_EDIT_SURCHARGE_PERCENT')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    }
                    </StyledGridContainer>

            <CustomizableFields
                CUSTOMIZABLE_FIELDS={ADDITIONAL_ATTRIBUTE_FIELDS}
                entity = "PRODUCT"
                config={productTextfieldsData}
                values={productDetail}
                setValues={setProductDetail}
                isViewMode = {isViewMode}
                handleOnChange={handleChangeProductField}
                errors={isRequired}
                />

    
        <EntityNote
        entityDetails = {productDetail} 
        onChange = {handleChangeProductField}
        headingLabel = {handleValidateCodevalue(internationalise,"COMMON_SPECIAL_NOTE")}
        />
</LeadAccordion>
                <DocumentManagement
                entityType='productId'
                url = {`${process.env.REACT_APP_BASE_URL}product/documents`}
                docType={docType}
                isViewMode={isViewMode}
                clientId = {productId}
                onSuccess={() => setIsAuditAccordionExpanded(false)}
                />


                {specificRolePermission?.isAuditView  && <div>
                    <LeadAccordion
                        label={handleValidateCodevalue(internationalise,'COMMON_AUDIT_LOGS')}
                        {...auditAccordion.accordionProps}
                    >
                        <AuditLogs
                            label = ""
                            isSearchRequired = {false}
                            entityDetails = {{
                                entityId: productId,
                                entity: "PRODUCT_SIDEBAR_MENU"
                            }}
                            module="Product"
                        />
                    </LeadAccordion>
                    
                </div>}
               
                
            </Box>
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
                    <Typography variant='h6'>
                        {`${handleValidateCodevalue(internationalise, 'PROD_EDIT_TITLE_EDIT')} - ${productId}`}
                    </Typography>
                
                <Button className='edit-primary btn-space' variant="outlined" onClick={goBack}>{handleValidateCodevalue(internationalise,'COMMON_BACK')}</Button>
                    {/* {
                    (specificRolePermission?.isProductManage && isViewMode) && 
                    <Button className='edit-primary' variant="outlined" onClick={()=>setIsViewMode(!isViewMode)}>{handleValidateCodevalue(internationalise,'COMMON_EDIT')}</Button>
                    } */}
            </Stack>
            </CreateLeadFooter>
        </BiztantuLoader>
    )
}



export default EditProduct;
